import { useEffect } from "react";
import { setUnreadBadge } from "lib/unreadBadge";
import { isDesktop, updateUnreadBadge } from "../desktop";

/**
 * Mirror the global unread thread count onto:
 *   - browser tab title ("(N) <app name>")
 *   - favicon overlay (red badge with number)
 *   - Electron dock/taskbar badge (macOS/Windows)
 */
export default function useUnreadBadge(unreadCount: number): void {
  useEffect(() => {
    setUnreadBadge(unreadCount);
    if (isDesktop) updateUnreadBadge(unreadCount);
  }, [unreadCount]);
}
